import Rest from '@/services/Rest';

/**
 * @typedef {FileService}
 */
export default class FileService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/attachment'
}